import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ApiFeaturesService, FeatureFlags } from './api-features.service';

/**
 * Stan flag macierzy. Cache trzymany NA INSTANCJI — nigdy w polu static. Pole statyczne
 * żyje w procesie SSR między requestami różnych klientów (patrz pułapka
 * ApiClientService.CACHED_CLIENT) i przeciekłoby flagi klienta A do klienta B.
 */
@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  readonly flags$ = new BehaviorSubject<FeatureFlags>({});

  private flags: FeatureFlags = {};

  constructor(private apiFeaturesService: ApiFeaturesService) {
  }

  load(): Observable<FeatureFlags> {
    return this.apiFeaturesService.getFeatures().pipe(
      tap(flags => {
        this.flags = flags ?? {};
        this.flags$.next(this.flags);
      }),
    );
  }

  isEnabled(name: string): boolean {
    return !!this.flags[name];
  }
}
